export default "__VITE_ASSET__d91d2130__"